export const SET_ME = 'ME/SET_ME';
export const RETRIEVE_ME = 'ME/RETRIEVE_ME';
